import type { SessionInfo } from '@term-deck/core/types';
import { pointLead, readableLinks } from '../point-card-text';
import { executorShort } from '../PointExecutor';
import { boardProjectName } from '../board-projects';
import { informativeOwner, rowStatus, rowWhen, type BoardItem } from './board-labels';

/**
 * DD.17 — uma linha por apontamento: marcador de estado, título, a frase que importa (seu ato / o que falta /
 * resultado) e quem está com ele. Tudo o mais — executor, conferência, provas — só no detalhe do selecionado.
 */
export function PointRow({ item, selected, executor, continuationLabel, onSelect, controlsId }: {
  item: BoardItem;
  selected: boolean;
  executor: SessionInfo | null;
  continuationLabel: string | null;
  onSelect: () => void;
  controlsId: string;
}) {
  const status = rowStatus(item);
  const lead = pointLead(item);
  const second = lead ? `${lead.label}: ${readableLinks(lead.text)}` : continuationLabel ?? (item.nextAction && item.state !== 'concluido' ? `Próxima ação: ${item.nextAction}` : null);
  const owner = informativeOwner(item);
  const meta = [
    boardProjectName(item),
    owner,
    item.origin === 'assistant' ? 'do Assistente' : item.origin === 'terminal' ? 'do terminal' : null,
    item.waitingOn?.length ? `aguarda ${item.waitingOn.length === 1 ? 'dependência' : `${item.waitingOn.length} dependências`}` : null,
    executor && item.state !== 'concluido' ? executorShort(executor) : null,
    rowWhen(item),
  ].filter(Boolean).join(' · ');
  return <button type="button" className="board-point-row" data-tone={status.tone} aria-expanded={selected} aria-controls={controlsId} onClick={onSelect}>
    <span className="board-point-row-title">{item.summary}</span>
    <span className="board-point-row-status">{status.label}</span>
    {second ? <span className="board-point-row-lead" data-kind={lead?.label === 'Seu ato' ? 'owner' : undefined}>{second}</span> : null}
    <span className="board-point-row-meta">{meta}</span>
  </button>;
}
